import React, { useEffect, useState, useMemo } from "react";
import { APIProvider, Map } from "@vis.gl/react-google-maps";
import {
  API_URL,
  GOOGLE_MAPS_MAP_ID,
  REACT_APP_GOOGLE_MAPS_KEY,
} from "../../actions/settings";
import { setKey, setLanguage, setRegion } from "react-geocode";
import LoadingDots from "./LoadingDots";
import { IonRow, IonSelect, IonSelectOption } from "@ionic/react";
import GoogleMapClusters from "./GoogleMapClusters";
// eslint-disable-next-line


interface Props {}

async function getBuildings(token: any,url:string) {
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((data) => data.json());
}

async function getAllPrimaryFunctions(token: any) {
  return fetch(`${API_URL}/energystar/primaryfunctions`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((data) => data.json());
}

async function getAllSubTypes(token: any) {
  return fetch(`${API_URL}/subtypes`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((data) => data.json());
}

const getPrimaryFunctions = async (token: any, setPrimaryfunctions: any) => {
  const primaryfunctions = await getAllPrimaryFunctions(
    `Token ${token.slice(1, -1)}`
  );
  setPrimaryfunctions(primaryfunctions);
};
const getSubTypes = async (token: any, setSubTypes: any) => {
  const subtypes = await getAllSubTypes(`Token ${token.slice(1, -1)}`);
  setSubTypes(subtypes);
};

const getItems = async (
  token: any,
  url:string,
  setBuildings: any
) => {
  const res = await getBuildings(`Token ${token.slice(1, -1)}`,url);
  if (res.status === "success") {
    setBuildings(res.data);
  } else {
    console.warn(res);
    setBuildings([]);
  }
};

const GoogleCustomersMapV2: React.FC<Props> = () => {
  //set react-geocode settings
  setKey(REACT_APP_GOOGLE_MAPS_KEY || "");
  setLanguage("en");
  setRegion("us");
  // end react-geocode settings
  const [loading, setLoading] = useState(true)
  const url = useMemo(() => new URL(`${API_URL}/map_buildings`), []);
  const [buildings, setBuildings] = useState([]);
  const [filters,setFilters] = useState<any>({
    'solution':'all',
    'building_type':'all',
    'building_sub_type':'all'
  })
  const [primaryfunctions, setPrimaryfunctions] = useState([]);
  const [subTypes, setSubTypes] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      const token = localStorage.getItem("token");
      getItems(token,url.toString(), setBuildings);
      getPrimaryFunctions(token, setPrimaryfunctions);
      getSubTypes(token, setSubTypes);
      setLoading(false)
    }, 3000);
  }, [url]);

  const handleFilter = (param:string,val:string) => {
    filters[param]=val;
    if(param==='building_type' && ! hasSubType()){
        filters['building_sub_type'] = 'all'
        url.searchParams.delete('building_sub_type')
    }
    setFilters(filters)
    if (val=== "all"){
      url.searchParams.delete(param)
    }else{
      url.searchParams.set(param,val)
    }

    setTimeout(()=>{
    const token = localStorage.getItem("token");
    getItems(token,url.toString(), setBuildings);
    },1000)
  }
  
  const hasSubType = ()=>{
     return subTypes.some((type: any) => type.property_type === filters['building_type'])
  }

  return (
    <APIProvider
      apiKey={REACT_APP_GOOGLE_MAPS_KEY || ""}
      key="map"
      version="beta"
    >
      <IonRow className="ion-justify-content-between" style={{width:'100%', margin:'0.5rem'}}>
        <div>Customers Map</div>
        <div style={{display:'flex'}}>
          <IonSelect style={{'width':'500px'}} interface="popover" labelPlacement="stacked" label='Building Type' value={filters['building_type']} onIonChange={(e)=>handleFilter('building_type',e.detail.value)}>
            <IonSelectOption value='all'>All</IonSelectOption>
            {primaryfunctions.map((type:any)=>{              
              return <IonSelectOption key={`type-${type.id}`} value={type.id}>{type.name}</IonSelectOption>
            })}
          </IonSelect>
          <IonSelect hidden={!hasSubType()} interface="popover" labelPlacement="stacked" label='Building Sub-Type' value={filters['building_sub_type']} onIonChange={(e)=>handleFilter('building_sub_type',e.detail.value)}>
            <IonSelectOption value='all'>All</IonSelectOption>
            {
              subTypes.map((type:any)=>{                
                if(filters['building_type']===type.property_type){
                  return <IonSelectOption key={type.uuid} value={type.uuid}>{type.sub_type_name}</IonSelectOption>
                }
                return null
              })
            }
          </IonSelect>
          <IonSelect interface='popover' labelPlacement="stacked" label='Solution Status' value={filters['solution']} onIonChange={(e)=>handleFilter('solution',e.detail.value)}>
            <IonSelectOption value='all'>All</IonSelectOption>
            <IonSelectOption value='foa'>FOA</IonSelectOption>
            <IonSelectOption value='kpi'>KPI</IonSelectOption>
            <IonSelectOption value='foakpi'>FOA + KPI</IonSelectOption>

          </IonSelect>          
        </div>
      </IonRow>
      <Map
        id="customersMap"
        style={{ width: "100%", height: "70vh" }}
        defaultCenter={{ lat: 42.25419, lng: -89.034959 }}
        defaultZoom={9}
        gestureHandling={"greedy"}
        disableDefaultUI={true}
        mapId={GOOGLE_MAPS_MAP_ID}
      >
        {loading ? (
          <div
            style={{
              position: "absolute",
              width: "100%",
              border: "black solid 3px",
              top: "0px",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              verticalAlign: "center",
              backgroundColor: "rgba(255,255,255,0.7)",
            }}
          >
            <LoadingDots style={{ position: "absolute", bottom: "50%" }} />
          </div>
        ) : null}

        <GoogleMapClusters buildings={buildings}/>
      </Map>
    </APIProvider>
  );
};

export default GoogleCustomersMapV2;
